export const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const isValid = emailRegex.test(email);
    return isValid
  };

export const validateNPI = (npi, setFormErrorState, name) => {
  let digit = name ? /^\d{9}$/.test(npi) : /^\d{10}$/.test(npi);
  if (!digit) {
    setFormErrorState((prev) => ({ ...prev, npi: { error: true, message: `${name || "NPI"} must be exactly ${name ? 9 : 10} digits` }, }));
  } else {
    setFormErrorState((prev) => ({ ...prev, npi: { error: false, message: "" }, }));
  }
};

export const formatEINInput = (input) => {
  const rawDigits = input.replace(/\D/g, "").slice(0, 9);

  const formattedEIN =
    rawDigits.length <= 2
      ? rawDigits
      : `${rawDigits.slice(0, 2)}-${rawDigits.slice(2)}`;

  return { rawDigits, formattedEIN };
};
